import { createSlice } from '@reduxjs/toolkit';

const initialState = 0;

const idSlice = createSlice({
  name: 'id',
  initialState,
  reducers: {},
});

export const idReducer = idSlice.reducer;
